// extracted by mini-css-extract-plugin
export default {"createNoteHolder":"Customer_createNoteHolder__AjtQ6","btnHolder":"Customer_btnHolder__-DVXZ"};